export enum AuthRoutes {
  blank = '/',
  dashboard = '/dashboard',
  users = '/users',
  vendors = '/vendors',
  customers = '/customers',
  profile = '/profile',
  changePassword = '/change-password',
  properties = '/properties',
}

export enum RouteParamsTypes {
  any = '/*',
  id = '/:id',
  blank = '',
  add = '/add',
  edit = '/edit',
  view = '/view',
  list = '/list',
  payout = '/payout',
}

export enum Modules {
  auth = '/auth',
  home = '/home',
  resources = '/resources',
  transactions = '/transactions',
  reservations = '/reservations',
  invoices = '/invoices',
  reconciliation = '/reconciliation',
  error = '/error',
  my = '/my'
}

export enum NonAuthRoutes {
  login = '/login',
  forbidden = '/forbidden',
  unHandledRejection = '/server-error',
  notFound = '/page-not-found',
  forgotPassword = '/forgot-password',
  resetPassword = '/reset-password'
}

export enum PermissionActionsEnum {
  View = "view",
  Add = "add",
  Update = "update",
  Delete = "delete",
  Email = "email",
  Export = "export",
  Import = "import",
  Complete = "complete",
  Verify = "invoice_verification",
  Active = "active"
}

export enum PermissionModulesEnum {
  Users = 'users',
  Dashboard = 'dashboard',
  Property = 'property',
  Customers = 'customer',
  Vendor = 'vendor',
  Transaction = 'transaction',
  Expense = 'expense',
  Reservation = 'reservation',
  Invoices = 'invoice',
  Payments = 'payment',
  ClientStatement = 'client_statement',
  Reconciliation = 'reconciliation_payout'
}

export enum SortOrder {
  asc = 'ASC',
  desc = 'DESC'
}

export enum RowClassName {
  even = 'even',
  odd = 'odd'
}

export enum RoleCodes {
  system_admin = 'system_admin',
  admin = 'admin',
  manager = 'manager',
}
